export default __webpack_public_path__ + "static/arturm-d896598f59c0fbf407d1f62940eb7dbf.png";